import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { ArrowLeft } from '../../lib/lucide-proxy';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await resetPassword(email);
    if (!error) {
      setSent(true);
    }
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>Recuperar Senha - Cerveja Delivery</title>
      </Helmet>
      <div className="min-h-screen bg-cream-300 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Link to="/login" className="flex items-center justify-center mb-6 text-dark-500 hover:text-primary-500">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Voltar para Login
          </Link>
          <div className="text-center">
            <h2 className="font-display font-bold text-3xl text-dark-900">
              Recuperar Senha
            </h2>
            <p className="mt-2 text-sm text-dark-600">
              Digite seu email para receber as instruções
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-soft rounded-2xl sm:px-10">
            {sent ? (
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                  <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-dark-900">Email enviado!</h3>
                <p className="mt-2 text-sm text-dark-500">
                  Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
                </p>
                <div className="mt-6">
                  <Link to="/login">
                    <Button variant="primary" className="w-full">
                      Voltar para Login
                    </Button>
                  </Link>
                </div>
              </div>
            ) : (
              <form className="space-y-6" onSubmit={handleSubmit}>
                <Input 
                  label="Email" 
                  type="email" 
                  required 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  placeholder="seu@email.com" 
                />
                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-full" 
                  loading={loading}
                >
                  Enviar Instruções
                </Button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;